const ArrowThin = () => {<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 12H3" stroke="#000"/>
    <path d="m13 4 8 8-8 8" stroke="#000" strokeLinecap="square"/>
</svg>
};

export default ArrowThin;